import { Link } from "react-router-dom";
import geLogo from "@assets/general-election/ge-logo-v1.svg";
import Icon from "@components/Icon/Icon";
import { IconTypeEnum } from "@components/Icon/types";
import { useSendInViewGTM } from "@pages/SingaporeGe/2025/hooks/useSendInViewGTM";
import { CandidatesLineUpProps } from "@pages/SingaporeGe/2025/utils/types";
import { cn, getFormattedUrlPath } from "@util/helpers";

export default function CandidatesLineUpBanner({
  configData: config,
  testId = "candidates-lineup-banner-component",
}: CandidatesLineUpProps): React.ReactElement {
  const { src = "", gaObject } = config || {};

  const parameters = gaObject?.parameters || [];
  const urlpath = getFormattedUrlPath(src, parameters);

  const { ref: candidatesRef } = useSendInViewGTM({
    eventsObject: gaObject?.eventObject,
  });

  return (
    <div
      data-testid={testId}
      ref={candidatesRef}
      className={cn(
        "relative mb-8 w-full border border-gray-850 text-gray-850",
        "bg-[url('/src/app/assets/general-election/banner_mobile.jpg')] bg-cover",
        "lg:bg-[url('/src/app/assets/general-election/banner_desktop.jpg')] lg:px-12 lg:py-6",
        config?.extraClass
      )}
    >
      <img
        src={geLogo}
        width={150}
        height={60}
        alt="Singapore GE 2025"
        className="m-auto w-[130px] pb-8 pt-52 lg:m-0 lg:w-[200px] lg:p-0"
      />

      <div className="absolute left-1/2 top-1/2 flex w-full -translate-x-1/2 -translate-y-1/2 items-center justify-center px-0 sm:px-10 lg:w-auto lg:px-0">
        <Link
          to={urlpath}
          target="_blank"
          className="mb-0 font-poppins text-xl font-semibold underline-offset-2 hover:underline"
        >
          SEE ALL THE CANDIDATES
        </Link>

        <div className="ml-1">
          <Icon
            type={IconTypeEnum.chrevonRightArrow}
            stroke="#2b2b2b"
            fill="none"
            size={24}
            viewBox="24"
          />
        </div>
      </div>
    </div>
  );
}
